import { render, staticRenderFns } from "./add-day.vue?vue&type=template&id=30b2677a&scoped=true"
import script from "./add-day.vue?vue&type=script&lang=js"
export * from "./add-day.vue?vue&type=script&lang=js"
import style0 from "./add-day.vue?vue&type=style&index=0&id=30b2677a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2677a",
  null
  
)

export default component.exports